import React from "react";
import { Link } from "react-router-dom";
import { PROFILE, NAV_LINKS } from "../data/content";

export const ProFooter = () => {
  return (
    <footer
      className="mt-24 border-t border-neutral-200 bg-white"
      data-testid="pro-footer"
    >
      <div className="max-w-6xl mx-auto px-5 md:px-8 py-14 grid md:grid-cols-3 gap-10">
        <div>
          <p className="font-plex font-medium text-neutral-900 text-lg">
            {PROFILE.fullName || PROFILE.name}
          </p>
          <p className="font-plex text-sm text-neutral-500 mt-1">{PROFILE.role}</p>
          <p className="font-plexMono text-xs text-neutral-500 mt-4 uppercase tracking-wider">
            {PROFILE.location}
          </p>
        </div>

        <div>
          <p className="font-plexMono text-xs uppercase tracking-wider text-neutral-500 mb-3">Navigate</p>
          <ul className="space-y-2">
            {NAV_LINKS.map((link) => (
              <li key={link.path}>
                <Link
                  to={link.path}
                  className="font-plex text-sm text-neutral-700 hover:text-terracotta transition-colors"
                  data-testid={`pro-footer-link-${link.label.toLowerCase()}`}
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="font-plexMono text-xs uppercase tracking-wider text-neutral-500 mb-3">Contact</p>
          <ul className="space-y-2">
            <li>
              <a
                href={`mailto:${PROFILE.email}`}
                className="font-plex text-sm text-neutral-700 hover:text-terracotta transition-colors"
                data-testid="pro-footer-email"
              >
                {PROFILE.email}
              </a>
            </li>
            <li>
              <a
                href={PROFILE.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="font-plex text-sm text-neutral-700 hover:text-terracotta transition-colors"
                data-testid="pro-footer-linkedin"
              >
                LinkedIn
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="max-w-6xl mx-auto px-5 md:px-8 pb-8">
        <p className="font-plexMono text-xs text-neutral-400">
          © {new Date().getFullYear()} {PROFILE.fullName || PROFILE.name}. All rights reserved.
        </p>
      </div>
    </footer>
  );
};
